import axios, { AxiosInstance } from 'axios';
export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || '').replace(/\/$/,'');
export const SESSION_CHANGED = 'ordinary-session-changed';
type Credential = { token: string; expiresAt: number };
let credential: Credential | null = null;
export function clearOrdinarySession() {
  credential = null;
  window.dispatchEvent(new Event(SESSION_CHANGED));
}
export function getOrdinaryToken(): string | null {
  if (credential && credential.expiresAt <= Date.now()) clearOrdinarySession();
  return credential?.token || null;
}
export function installOrdinarySession(token: string, expiresIn: number, startedAt = Date.now()) {
  if (!token || !Number.isInteger(expiresIn) || expiresIn <= 0 || expiresIn > 900) throw new Error('Неверный срок сессии');
  const expiresAt = startedAt + expiresIn * 1000;
  if (expiresAt <= Date.now()) throw new Error('Срок сессии истёк');
  credential = { token, expiresAt };
  window.dispatchEvent(new Event(SESSION_CHANGED));
  return expiresAt;
}
export function configureOrdinaryApi(client: AxiosInstance) {
  client.interceptors.request.use(config => {
    const token = getOrdinaryToken();
    const base=new URL(API_BASE_URL||'/',window.location.origin);
    const target=new URL(config.url||'',config.baseURL?new URL(config.baseURL,base).href:base.href);
    if (token && target.origin===base.origin && target.pathname.startsWith('/api/') && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  client.interceptors.response.use(response => response, error => {
    const authorization = error.config?.headers?.Authorization;
    if (error.response?.status === 401 && authorization && authorization === `Bearer ${getOrdinaryToken()}`) clearOrdinarySession();
    return Promise.reject(error);
  });
}
axios.defaults.baseURL = API_BASE_URL;
configureOrdinaryApi(axios);
export const ordinaryApi = axios;
